import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { SkeletonBlock } from "@/components/podkit/loading/Skeleton";
import { MemberIcon } from "@/components/settings/organization/members/MemberIcon";
import { useCurrentMember } from "@/hooks/use-current-member";
import { type FC } from "react";

export const UserAvatar: FC<PropsWithClassName> = ({ className }) => {
    const { currentMember } = useCurrentMember();
    if (!currentMember) {
        return <SkeletonBlock className="size-5 shrink-0 rounded-full" ready={false} animate={false} />;
    }

    if (!currentMember.avatarUrl) {
        return <MemberIcon name={currentMember.fullName} className={cn("size-5 shrink-0", className)} />;
    }

    return (
        <img
            src={currentMember.avatarUrl}
            alt={`${currentMember.fullName}'s avatar`}
            referrerPolicy="no-referrer"
            className={cn("size-5 shrink-0 rounded-full", className)}
        />
    );
};
